var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgColors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 955,
    viewBox: "0 0 1440 955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1270_27037)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1101,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    filter: "url(#filter0_f_1270_27037)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 970.724,
    cy: 342.551,
    rx: 310.685,
    ry: 190.564,
    transform: "rotate(21.3384 970.724 342.551)",
    fill: "#F1557F",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    filter: "url(#filter1_f_1270_27037)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 518.546,
    cy: 630.34,
    rx: 334.058,
    ry: 187.105,
    transform: "rotate(43.8406 518.546 630.34)",
    fill: "#0078FF",
    fillOpacity: 0.58
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1270_27037)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1078.15,
    cy: 732.571,
    rx: 317.121,
    ry: 194.512,
    transform: "rotate(21.3384 1078.15 732.571)",
    fill: "#C855F1",
    fillOpacity: 0.19
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1270_27037",
    x: 363.078,
    y: -177.92,
    width: 1215.29,
    height: 1040.94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 155,
    result: "effect1_foregroundBlur_1270_27037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1270_27037",
    x: -65.0977,
    y: 52.4297,
    width: 1167.29,
    height: 1155.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 155,
    result: "effect1_foregroundBlur_1270_27037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1270_27037",
    x: 464.34,
    y: 207.738,
    width: 1227.63,
    height: 1049.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 155,
    result: "effect1_foregroundBlur_1270_27037"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1270_27037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1101,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgColors);
export default __webpack_public_path__ + "static/media/bg-colors.c6d5267c71af4de0e9b84062fc9aa31d.svg";
export { ForwardRef as ReactComponent };